import { render, staticRenderFns } from "./DownloadNoticeSection.vue?vue&type=template&id=45738c4b&scoped=true"
import script from "./DownloadNoticeSection.vue?vue&type=script&lang=js"
export * from "./DownloadNoticeSection.vue?vue&type=script&lang=js"
import style0 from "./DownloadNoticeSection.vue?vue&type=style&index=0&id=45738c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45738c4b",
  null
  
)

export default component.exports